export default __webpack_public_path__ + "static/media/profile.b3e391f4.jpg";